export default __webpack_public_path__ + "static/media/FeaturedEventsIcon4.4d7e195c.png";